import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, remove, update, get, onValue, off, push, onChildChanged } from "firebase/database";
import { getAuth, onAuthStateChanged, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAGyZnq98BAVdVvv7lN42ggjbi2teW8zpk",
  authDomain: "pese-consulting-gx.firebaseapp.com",
  projectId: "pese-consulting-gx",
  storageBucket: "pese-consulting-gx.firebasestorage.app",
  messagingSenderId: "390978232402",
  appId: "1:390978232402:web:af93c701c4cc4a5524ff8b",
  measurementId: "G-VEHSMVT3JW"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getDatabase(app);


// set( ref(db, '/'),{
//   name:'Rayman Li',
//   age: 44,
//   stressLevel: 6,
//   job:{
//     title: "Developer",
//     company:"Google"
//   },
//   location:{
//     city: "Philadelphia",
//     country: 'US'
//   }
// }).then( (data) =>{
//   console.log("Data is saved: " + data);
// }).catch((err)=>{
//   console.log("Error when saving: " , err);
// });


// remove( ref(db, '/')).then( (data) =>{
//   console.log("Data is removed: " + data);
// }).catch((err)=>{
//   console.log("Error: " , err);
// });

// update( ref(db),{
//   '/stressLevel': 9,
//   '/job/company': 'Amazon',
//   '/location/city':'Seattle'
// }).then( (data) =>{
//   console.log("Data is updated: " + data);
// }).catch((err)=>{
//   console.log("Error: " , err);
// });

// get( ref(db, '/')).then( (snapshot) =>{
//   console.log(snapshot.val());
// } )

// var removeValueChangeHook =onValue(  ref(db, '/'), (snapshot)=>{
//   console.log( snapshot.val());
// }, (e)=>{
//   console.log("Err: ", e);
// })


// setTimeout( ()=>{
//   removeValueChangeHook();
// }, 5000);

// const listRef = ref(db, 'notes');

// const note1Ref = push(listRef);
// set(note1Ref, {
//   description:"Expense 2",
//   amount: 300,
//   date: "2022/3/1"
// }).then( () =>{
//   console.log("Data is saved. ");
// }).catch((err)=>{
//   console.log("Error when saving: " , err);
// });;

// var removeValueChangeHook =onValue( listRef, (snapshot)=>{
//   var notes = [];
//   snapshot.forEach( (chlidSnapshot) =>{
//     var note = chlidSnapshot.val();
//     var idObj = {id: chlidSnapshot.key};
//     notes.push( Object.assign({
//         id: chlidSnapshot.key
//       }, note )
//     );
//   });
//   console.log( notes);
// }, (e)=>{
//   console.log("Err: ", e);
// });

// onChildChanged(listRef, (snapshot)=>{
//   console.log(snapshot.key, snapshot.val());
// })


const auth = getAuth(app);
auth.useDeviceLanguage();


export { auth, db as default };
export * from './user';
